import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.to-string.js";
import axios from 'axios';
import { Message } from 'element-ui';
import qs from 'qs';
import $config from '@/config';
import store from '@/store';
import { getToken } from '@/utils/auth';
import router from '@/router';
//创建axios实例
var timeout = 10000;
var request = axios.create({
  baseURL: $config.baseUrl,
  timeout: timeout
});
//请求拦截器
request.interceptors.request.use(function (config) {
  //判断是否formDate格式
  if (config.headers.isQs) {
    config.data = qs.stringify(config.data); // 转为formdata数据格式s
  }

  if (store.getters.token) {
    config.headers['Authorization'] = getToken();
    // config.headers['Authorization'] = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJEZXBhcnRtZW50Q29kZSI6IkQwMDAwMCIsIkhvc3BpdGFsQ29kZSI6IkgwMDAwMDEiLCJEZXBhcnRtZW50TmFtZSI6IuWFqOiniCIsIlN0YWZmTG9naW4iOiJIMDAwMDAxYWRtaW4iLCJTdGFmZkNvZGUiOiJTVDAwMDE0IiwiU3RhZmZOYW1lIjoiYWRtaW4ifQ.7eepAgL3M8mwY2uFn7AYGuk_c1PohbDKc_Usa3bDkcg'
  }

  return config;
});
//响应拦截器
request.interceptors.response.use(function (response) {
  var data = response.data;
  if (data.code == 20000) {
    return response.data;
  } else if (data.code == 20014) {
    store.dispatch('user/logout');
    router.replace('/login');
  } else {
    Message.error(data.msg);
    return Promise.reject(new Error(data.msg));
  }
}, function (error) {
  // console.log(1111, error);
  //处理网络错误
  var msg = '';
  if (error == "Error: timeout of ".concat(timeout, "ms exceeded") || error == 'Error: Network Error') {
    msg = '网络请求超时,请联系服务器管理员后重试';
  }
  if (error && error.response && error.response.status) {
    var status = error.response.status;
    switch (status) {
      case 400:
        msg = '请求参数错误';
        break;
      case 401:
        msg = 'token过期';
        break;
      case 403:
        msg = '无权访问';
        break;
      case 404:
        msg = '请求地址错误';
        break;
      case 500:
        msg = '服务器出现问题';
        break;
      default:
        msg = '无网络';
    }
  }
  Message.close();
  Message.error(msg);
  return Promise.reject(error);
});
export default request;
export var get = function get(url, params) {
  return request({
    url: url,
    params: params,
    method: 'get'
  });
};

/** @param {Boolean} isQs */
export var post = function post(url, data) {
  var isQs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return request({
    url: url,
    data: data,
    method: 'post',
    headers: isQs ? {
      isQs: isQs
    } : {
      "Content-Type": 'application/json'
    }
  });
};